import { useGetAccountsQuery } from "@/redux/api/accounts.rtkq";
import { useGetPlansQuery } from "@/redux/api/plans.rtkq";
import { useGetAppsQuery } from "@/redux/api/apps.rtkq";
import PageHeader from "@/components/super-admin/PageHeader";
import StatsOverview from "@/components/super-admin/StatsOverview";
import MainTabs from "@/components/super-admin/MainTabs";

const SuperAdminPage = () => {
  // Fetch real data from backend
  const { data: accounts, isLoading: accountsLoading } = useGetAccountsQuery();
  const { data: plans, isLoading: plansLoading } = useGetPlansQuery();
  const { data: apps, isLoading: appsLoading } = useGetAppsQuery();

  return (
    <div className="min-h-screen min-w-0 bg-indigo-50" dir="rtl">
      <PageHeader />

      <div className="w-full min-w-0 px-4 py-4">
        <StatsOverview
          accounts={accounts}
          plans={plans}
          apps={apps}
          accountsLoading={accountsLoading}
          plansLoading={plansLoading}
          appsLoading={appsLoading}
        />

        <MainTabs />
      </div>
    </div>
  );
};

export default SuperAdminPage;
